/* tslint:disable:max-line-length */
import React from 'react';
import { IconTypeProps } from '../types';
import classNames from 'classnames';

export const CustomerChatIcon = ({
  className,
  style,
  color = '#938BB7',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      viewBox="0 0 16 17"
      width="16"
      height="17"
      fill="none"
      style={style}
    >
      <g clipPath="url(#clip0)">
        <path
          d="M10.4 4.29a.503.503 0 11-1.005.001.503.503 0 011.005 0zM12.315 4.29a.503.503 0 11-1.005.001.503.503 0 011.005 0zM14.23 4.29a.503.503 0 11-1.006.001.503.503 0 011.006 0z"
          fill="#fff"
        />
        <path
          d="M6.938 14.786h2.294a.314.314 0 100-.629H6.938a.314.314 0 000 .629z"
          fill={color}
        />
        <path
          d="M16 6.11V2.6a.944.944 0 00-.943-.943h-.415a.314.314 0 100 .629h.415c.174 0 .315.14.315.314v3.51a.315.315 0 01-.315.315h-3.543a.314.314 0 00-.237.108l-.763.88-.859-.892a.314.314 0 00-.226-.096h-.862a.315.315 0 01-.314-.315v-.883a.317.317 0 000-.16V3.85a.316.316 0 000-.16V2.6c0-.173.141-.314.314-.314h3.577a.314.314 0 100-.629H8.567a.944.944 0 00-.942.943v.855H1.72a.944.944 0 00-.942.943v8.6H.314a.314.314 0 00-.314.314v1.583c0 .52.423.943.943.943h14.045c.52 0 .943-.423.943-.943v-1.583a.314.314 0 00-.314-.314h-.35V7.029A.944.944 0 0016 6.11zm-.698 8.785a.314.314 0 01-.314.314H.943a.314.314 0 01-.315-.314v-1.269h14.674v1.27zM8.567 7.053h.728l1.004 1.044c.06.061.141.096.227.096h.008a.314.314 0 00.23-.108l.894-1.032h1.654v4.573H8c-.046 0-.333.124-.333 0H4.107 2.864V5.46h4.76v.65c0 .52.424.942.943.942zm-7.16-2.655c0-.173.14-.314.313-.314h5.905v.748H2.55a.314.314 0 00-.314.314v6.794c0 .173.14.314.314.314h11.077c.173 0 .314-.14.314-.314V7.053h.698v5.906H1.406V4.398z"
          fill={color}
        />
        <path
          d="M9.08 4.276a.818.818 0 001.635 0 .818.818 0 00-1.634 0zm1.006 0a.189.189 0 11-.377 0 .189.189 0 01.377 0zM11.812 3.459a.818.818 0 000 1.634.818.818 0 000-1.634zm0 1.005a.189.189 0 110-.377.189.189 0 010 .377zM13.727 5.093a.818.818 0 10-.002-1.636.818.818 0 00.002 1.636zm0-1.006a.189.189 0 110 .378.189.189 0 010-.378zM4.682 11.083h-1.03c-.176 0-.319-.133-.319-.297V9.714c0-.164.143-.297.319-.297.176 0 .318.133.318.297v.774h.712c.175 0 .318.133.318.298 0 .164-.143.297-.318.297zM5.765 11.067l-.006.002a.33.33 0 01-.411-.222.333.333 0 01.22-.414l.006-.002a.333.333 0 01.19.636zM1.493 14.771l.006.002a.314.314 0 00.18-.602l-.006-.002a.314.314 0 10-.18.602zM2.276 14.771l.006.002a.314.314 0 10.18-.602l-.005-.002a.314.314 0 00-.18.602zM3.06 14.771l.006.002a.314.314 0 00.18-.602l-.006-.002a.314.314 0 00-.18.602zM12.857 14.771l.006.002a.314.314 0 00.18-.602l-.005-.002a.314.314 0 00-.18.602zM13.64 14.771l.007.002a.314.314 0 00.18-.602l-.006-.002a.314.314 0 10-.18.602zM14.424 14.771l.006.002a.316.316 0 00.391-.21.314.314 0 00-.21-.392l-.006-.002a.314.314 0 00-.18.602zM13.303 2.272l.006.001a.312.312 0 00.391-.21.314.314 0 00-.21-.392l-.007-.001a.314.314 0 10-.18.602z"
          fill={color}
        />
        <rect
          x="9.333"
          y="8.75"
          width="3.333"
          height="2.333"
          rx="1.167"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <path d="M0 .75h16v16H0v-16z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
};
